import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = process.env.REACT_APP_GLANCE_SERVER_URL;


const responseBody = res => res.body;

let token = null;


const tokenPlugin = req => {
  if (token) {
    req.set('Authorization', `Bearer ${token}`);
  }
}

// eslint-disable-next-line
const requests = {
  del: url =>
    superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  get: url =>
    superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  put: (url, body) =>
    superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody)
};

const Auth = {
  login: (email, password) => superagent.post(`${API_ROOT}/glance/login`, { username: email, password: password, type: "View" }).then(responseBody)
};

const View = {
  getConfig: (configurationId) => requests.get(`/glance/view/${configurationId}`),
  updateLayout: (configurationId, pageId, layouts) => superagent.post(`${API_ROOT}/glance/view/updatelayout`, {configurationId:configurationId, internalId:pageId, layouts:layouts}).use(tokenPlugin).then(responseBody)
}

const MeetingRoom = {
  getEvents: (resourceId, time) => requests.get(`/crm/event/${resourceId}/${time}`),
  getNextEventForAllResources: (time, date) => requests.get(`/crm/eventsall/${time}/${date}`)
}

const Entity = {
  getEmployees: () => requests.get('/entity/employee')
}

const Search = {
  executeSearch: (savedSearchId, searchResultType, bypassCache) => requests.get(`/search/${searchResultType}/${savedSearchId}?bypassCache=${bypassCache}`),
  executeColumnSearch: (savedSearchId, bypassCache, columnValue, resultIsImage) => requests.get(`/search/column/${savedSearchId}?column=${columnValue}&bypassCache=${bypassCache}&resultIsImage=${resultIsImage}`),
  executeBarChartSearch: (savedSearchId, bypassCache, yAxisColumn, xAxisColumn) => requests.get(`/search/barchart/${savedSearchId}?yAxisColumn=${yAxisColumn}&xAxisColumn=${xAxisColumn}&bypassCache=${bypassCache}`),
  executeComboChartSearch: (savedSearchId, bypassCache, yAxisColumn, xAxisColumn, yAxisColumnLine, savedSearchLineId) => requests.get(`/search/combo/${savedSearchId}?yAxisColumn=${yAxisColumn}&xAxisColumn=${xAxisColumn}&yAxisColumnLine=${yAxisColumnLine}&savedSearchLineId=${savedSearchLineId}&bypassCache=${bypassCache}`),
  executePieChartSearch: (savedSearchId, bypassCache, nameColumn, valueColumn) => requests.get(`/search/piechart/${savedSearchId}?nameColumn=${nameColumn}&valueColumn=${valueColumn}&bypassCache=${bypassCache}`),
  executeStackedBarChartSearch: (savedSearchId, bypassCache, yAxisColumns, xAxisColumn) => requests.get(`/search/stackedbarchart/${savedSearchId}?yAxisColumns=${yAxisColumns}&xAxisColumn=${xAxisColumn}&bypassCache=${bypassCache}`)
}

export default {
  Auth,
  View,
  MeetingRoom,
  Entity,
  Search,
  setToken: _token => { token = _token; }
};



// WEBPACK FOOTER //
// ./src/agent.js